import React, { useState, useEffect } from 'react';
import {
    Alert,
    Button,
    Checkbox,
    CircularProgress,
    Grid,
    InputAdornment,
    MenuItem,
    Paper,
    TextField,
    Tooltip
} from '@mui/material';
import {
    Cached as CachedIcon,
    CallMissedOutgoing as CallMissedOutgoingIcon,
    TaskAlt as TaskAltIcon,
    ThumbUpAlt as ThumbUpAltIcon,
} from '@mui/icons-material';
import "./styles/styles.css";
import { useAuth } from "../../Auth";
import { clientsService } from './helpers/clientsService';
import { ConfirmProvider, useConfirm } from "material-ui-confirm";
import { SnackbarProvider, useSnackbar } from 'notistack';

const Module = () => {
    const confirm = useConfirm();
    const { authTokens, setRuta } = useAuth();
    const { enqueueSnackbar} = useSnackbar()
    const [ getZonas, setZonas ] = useState([]);
    const [ zonaBack, setZonaBack ] = useState('');
    const [ zonaNew, setZonaNew ] = useState('');
    const [ zonaBackObject, setZonaBackObject ] = useState({Zona:''});
    const [ zonaNewObject, setZonaNewObject ] = useState({Zona:''});
    const [ totalClientes, setTotalClientes ] = useState(0);
    const [ getClientes, setClientes ] = useState([]);
    const [ selecting, setSelecting ] = useState(false);
    const [ affected, setAffected ] = useState(0);
    const [ isContinuo, setContinuo ] = useState(false);
    const [ isProcessing, setProcessing ] = useState(false);
    const [ planes, setPlanes ] = useState([]);
    const [ isSameMk, setSameMk ] = useState(false);
    const [ isUnMount, setUnMount ] = useState(false);

useEffect(()=>{
    setRuta('/Clientes/MigracionMk');
    (async ()=>{
        const dataZonas = await fetch(`/api/zonas/byEmpresa/${authTokens.Empresa}`);
        const resultZonas = await dataZonas.json();
        const dataPlanes = await fetch(`/api/Planes`);
        const resultPlanes = await dataPlanes.json();
        setPlanes(resultPlanes);
        if(authTokens.Type === 'ADMINISTRADOR'){
            setZonas(resultZonas);
        }else{
            const ZonasArr = authTokens.Zonas.map(valZon => valZon.Zona);
            const arrFilZona = resultZonas.filter(value => ZonasArr.includes(value.Zona.toString()));
            setZonas(arrFilZona);
        }
    })()
},[]); // eslint-disable-line react-hooks/exhaustive-deps

useEffect(()=>{
    if(isContinuo){
        setContinuo(false);
        setTimeout(()=>{
            console.log(affected)
            handleProcesar();
        },1000)
    }
},[isContinuo]); // eslint-disable-line react-hooks/exhaustive-deps

useEffect(()=>{
    if(isUnMount) setUnMount(false);
},[isUnMount]); // eslint-disable-line react-hooks/exhaustive-deps

const handleZonaBack = ({target})=>{ 
    if(target.value === zonaNew){
        enqueueSnackbar('SELECCIONE OTRA ZONA', {variant:'warning'});
        return;
    }
    setSelecting(true);
    setZonaBack(target.value);
    setZonaBackObject(getZonas.find(el=>el.Zona === target.value))
    fetch('/api/clientes/byEmpresa&Zona', { 
        method:'POST', 
        body: JSON.stringify({Empresa:authTokens.Empresa, Zona:target.value}), 
        headers:{'Content-Type': 'application/json'}
    }) 
    .then(response=> response.json())
    .then(async result =>{
        if(result.Status){
            enqueueSnackbar(result.status, {variant:'error'});
        }else{
            const clients_ = await clientsService(result, target.value);
            setClientes(clients_);
            setTotalClientes(clients_.length);
            setSelecting(false);
            enqueueSnackbar('CLIENTES CARGADOS CON ÉXITO', {variant:'info'});
        }
    });
};

const handleZonaNew = ({target})=>{ 
    if(target.value === zonaBack){
        enqueueSnackbar('SELECCIONE OTRA ZONA', {variant:'warning'});
        return;
    }
    setZonaNew(target.value);
    setZonaNewObject(getZonas.find(el=>el.Zona === target.value));
};

const handleProcesar = ()=>{
    if(affected === totalClientes){
        enqueueSnackbar('MIGRACIÓN REALIZADA CON ÉXITO', {variant:'success'})
        setProcessing(false);
        setTimeout(()=>{
            handleReset();
        },4000)
        return;
    }
    const Zonas = getClientes[affected].Zonas.filter(el=> el.Zona === zonaBack);
          Zonas.push(isSameMk ?  zonaBack : zonaNew);
    const zoneChange = isSameMk ? {...zonaBackObject} : {...zonaNewObject};
    if(!zoneChange.planLocal) zoneChange.Planes = planes
    
    fetch('/api/clientes/MigracionMk', { 
        method:'POST', 
        body: JSON.stringify({
            Empresa:authTokens.Empresa, 
            zonaBack,
            zoneChange,
            cliente:getClientes[affected],
            Zonas
        }), 
        headers:{'Content-Type': 'application/json'}
    }) 
    .then(response=> response.json())
    .then(async result =>{
        if(result.message){
            console.log(`Cliente ${getClientes[affected].Nombres} Migrado`)
            setProcessing(true);
            setAffected(old=> old + 1);
            setContinuo(true);
            return;
        }

        enqueueSnackbar(result.status, {variant:'error'});
    });

};

const handleValidate = ()=>{
    confirm({ 
        title: "DESEA PROCEDER?",
        confirmationText:'SI',
        confirmationButtonProps:{
            color:'primary',
            variant:'contained',
            endIcon:<ThumbUpAltIcon/>
        },
        titleProps:{
            className:"dialog-title",
            sx:{ boxShadow: 1 }
        },
        dialogProps:{
            maxWidth:'xs'
        }
    })
    .then(() => {
        handleProcesar()
    })
    .catch(() => {
      console.log('CANCELADO')
    });
};

const handleSame = ({target})=>{
    setSameMk( target.checked )
    setZonaNew("");
    setZonaNewObject({});
};

const handleReset = ()=>{
    setSameMk(false);
    setZonaBack("");
    setZonaNew("");
    setZonaBackObject({});
    setZonaNewObject({});
    setAffected(0);
    setClientes([]);
    setTotalClientes(0);
    setUnMount(true);
};

  return (
    <Grid 
        alignItems='center'
        container
        justifyContent='center'
        spacing={1}
        className="grid-root">
            <Grid 
                item
                xs={12}
                md={6}
                lg={4}
                xl={3}>
                    <Paper
                        square
                        elevation={2}
                        className="paper-root">
                                <Grid 
                                    alignItems='center'
                                    container
                                    justifyContent='center'
                                    spacing={2}>
                                        <Grid item xs={10}>
                                            <TextField
                                                label="Previous Zone"
                                                value={ zonaBack || '' }
                                                onChange={handleZonaBack}
                                                fullWidth
                                                InputProps={{
                                                    startAdornment: (
                                                      <InputAdornment position="start">
                                                        {selecting && <CircularProgress size={20}/>}
                                                      </InputAdornment>
                                                    ),
                                                }}
                                                // variant="outlined"
                                                select>
                                                { getZonas.map(el=><MenuItem key={el.Zona} value={el.Zona}>{el.Zona}</MenuItem>)}
                                            </TextField>
                                        </Grid>
                                        <Grid item xs={2}>
                                            {!isUnMount && 
                                            <Tooltip
                                                placement='top'
                                                arrow
                                                title="NUEVO MK">
                                                    <span>
                                                    <Checkbox
                                                        // {...label}
                                                        value={isSameMk || false}
                                                        disabled={zonaBack === "" ?? false}
                                                        onChange={handleSame}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                                    />
                                                    </span>
                                            </Tooltip>}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                label="New Zone"
                                                value={ zonaNew || '' }
                                                onChange={handleZonaNew}
                                                disabled={zonaBack !== "" ? isSameMk ? true : false : true}
                                                fullWidth
                                                select>
                                                { getZonas.map(el=><MenuItem key={el.Zona} value={el.Zona}>{el.Zona}</MenuItem>)}
                                            </TextField>
                                        </Grid>
                                        { zonaNew !== "" || isSameMk ?
                                            <>
                                                <Grid item xs={12}>
                                                    <Paper square elevation={1} className="paper-info">
                                                        <Grid container spacing={1} justifyContent='center' alignItems="center">
                                                            <Grid item className="element-center">
                                                                {`CLIENTES: ${totalClientes}/${affected}`}
                                                            </Grid>
                                                            <Grid item className="element-center"> 
                                                                {isProcessing && <CircularProgress size={20}/>}
                                                                {affected === 5 && !isProcessing && <TaskAltIcon color="success"/>}
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Grid> 
                                                <Grid item xs={12}>
                                                    <Alert severity="warning">Este proceso afectará varias tablas en su db!</Alert>
                                                </Grid>
                                            </> : null
                                            
                                        }
                                        <Grid item xs={6}>
                                            <Button
                                                fullWidth
                                                color="error"
                                                size="large"
                                                variant="contained"
                                                endIcon={<CachedIcon/>}
                                                
                                                onClick={handleReset}>
                                                RESET
                                            </Button>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Button
                                                fullWidth
                                                color="primary"
                                                size="large"
                                                variant="contained"
                                                endIcon={<CallMissedOutgoingIcon/>}
                                                disabled={zonaNew === "" ? isSameMk ? false : true : false}
                                                onClick={handleValidate}>
                                                INICIAR
                                            </Button>
                                        </Grid>
                                </Grid>
                    </Paper>
            </Grid>
    </Grid>
  )
};

export const MigracionMk = ()=> 
<SnackbarProvider maxSnack={3} hideIconVariant={false} dense >
    <ConfirmProvider>
        <Module/>
    </ConfirmProvider>
</SnackbarProvider>;
